<light-layout>
  <div class="__page-root">
    <hero name="DevOps Transformation" kicker="Strategy & Roadmap.">
      <div class="cover-image hero-background tinted"></div>
      <back-to-button></back-to-button>
    </hero>
    <div class="sections">
      <app-summary color="#ffc200"
                   content="Data Concepts’ client was mired in organizational change and needed help improving their processes due to a failed Agile approach and a lack of communication across the twelve teams in their eCommerce division.">
        <role [style.width.%]="100">
          <li>Agile Reengineering</li>
          <li>DevOps</li>
          <li>CI/CD</li>
          <li>Automation</li>
          <li>Organizational Transformation</li>
        </role>
      </app-summary>

      <challenge color="#ffc200"
                     content="The workforce used Agile methodologies, however, automation was limited and organizational redundancies resulted in duplicate effort and waste. A culture centered on delivery deadlines had tattered morale and communication while simultaneously ignoring individual and team growth. A new corporate vice president mandated the group transition to a DevOps model, a significant transformation melding development, operations, and support by extending Agile principles and test automation through the deployment process to increase software quality and reliability while reducing waste. DevOps would also empower the teams by promoting a culture of cooperation, accountability, continuous improvement, and growth."></challenge>

      <solution-header content="a tailored devops solution designed for collaboration"></solution-header>

      <solution>
        <p>Data Concepts crafted and implemented a detailed roadmap for the eCommerce division to reach full DevOps maturity with predictable stability in all environments. The project entailed several steps:</p>
        <ul class="pseudo">
          <li>- Establish a new Continuous Integration / Continuous Delivery [CI/CD] pipeline.</li>
          <li>- Streamline roles and responsibilities.</li>
          <li>- Make quality the focus throughout the development cycle, starting with improving the format for user stories with rigorous Definitions of Done, as well as employing better automation.</li>
          <li>- Build team morale.</li>
        </ul>
      </solution>

      <outcome color="#ffc200"
                   content="Ultimately, Data Concepts delivered tangible, immediate value through a DevOps strategy and roadmap tailored to the exact needs of the eCommerce group, complete with vision, measurable goals and recommendations that were immediately actionable. Successful execution excited leadership, as it meant a transition from DevOps to NoOps, where optimization is built into testing and automation to such an extent that operations is “hands off” in the deployment process. The realized transformation in the software development process and the capacity of each employee resulted in a better product, significant efficiency gains, and a culture of improved teamwork and communication."></outcome>
    </div>
  </div>
</light-layout>
